import { environmentHttpClient as httpClient } from "../httpClient";

const FEATURE_API = "UiApi/AiAssistant";

export type AiAssistantBrandingModel = {
	namesByLocale: Readonly<Record<string, string>>;
	smallAvatarUrl: string;
};

export function getBranding(
	signal?: AbortSignal
): Promise<AiAssistantBrandingModel | null> {
	return httpClient.get<AiAssistantBrandingModel | null>(
		`${FEATURE_API}/Branding`,
		undefined,
		{ signal }
	);
}

export enum RewriteToolContentKind {
	PlainText = 1,
	Html = 2
}

export enum RewriteToolKind {
	MakeShorter = 1,
	MakeLonger = 2,
	FixSpelling = 3,
	ChangeTone = 4,
	Translate = 5
}

export type RewriteOperation = {
	kind: RewriteToolKind.MakeShorter
		| RewriteToolKind.MakeLonger
		| RewriteToolKind.FixSpelling;
} | {
	kind: RewriteToolKind.ChangeTone;
	tone: RewriteToneKind;
} | {
	kind: RewriteToolKind.Translate;
	language: TranslateLangKind;
};

export enum RewriteToolTargetKind {
	Generic = 1,
	Email = 2,
	Announcement = 3,
	KnowledgeItem = 4,
	Event = 5
}

export type RewriteToolInputModel = {
	content: string;
	contentKind: RewriteToolContentKind;
	operation: RewriteOperation;
	target: RewriteToolTargetKind;
};

export type RewriteToolResponseModel = {
	content: string;
};

export enum RewriteToneKind {
	Professional = 1,
	Casual = 2,
	Empathic = 3
}

export enum TranslateLangKind {
	Dutch = 1,
	French = 2,
	German = 3,
	English = 4
}

export function rewrite(
	request: RewriteToolInputModel,
	signal?: AbortSignal
): Promise<RewriteToolResponseModel> {
	return httpClient.post<RewriteToolResponseModel>(
		`${FEATURE_API}/Rewrite`,
		request,
		{ signal }
	);
}
